export default "assets/images/icons/people-ca4bf2ed.svg";